import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import {
  breakpoint,
  duration,
  size,
  width,
} from '@twistopayments/design-system/styles'

export const globalNavigationStyles = css`
  body {
    overflow: clip;
  }
`

export const header = (theme: Theme) => css`
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: ${theme.palette.background.main};
  width: 100%;
  transition: box-shadow ${duration.short}ms ease-out;
`

export const light = (theme: Theme) => css`
  background-color: ${theme.palette.background.main};
`

export const dark = (theme: Theme) => css`
  background-color: ${theme.palette.primary.mainContrast};
`

export const headerScrolled = (theme: Theme) => css`
  box-shadow: ${theme.shadows.boxHover};
  transition: box-shadow ${duration.short}ms ease-in;
`

export const navigation = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: ${width.container.wider};
  margin: 0 auto;
  padding: 10px ${size[24]};

  ${breakpoint.up('md')} {
    gap: ${size[32]};
    padding: ${size[24]};
  }
`

export const primaryContainer = css`
  gap: clamp(${size[32]}, 4vw, ${size[64]});
  width: unset;
`

export const primary = (theme: Theme) => css`
  display: none;

  ${breakpoint.up('lg')} {
    display: flex;
    gap: clamp(${size[24]}, 1vw + ${size[16]}, ${size[32]});
    margin: 0;
    padding: 0;
    overflow-x: auto;

    & > * {
      min-width: max-content;
    }

    &::-webkit-scrollbar {
      width: ${size[8]};
      height: ${size[8]};
      background-color: transparent;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: ${size[12]};
      background-color: ${theme.palette.ghost.mediumContrast};
      border: 1px solid ${theme.palette.background.main};
    }
  }
`
